import html2canvas from 'html2canvas';
import { Api } from './new';

export const takeScreenshot = async (selector = 'body'): Promise<void> => {
    try {
        const element = document.querySelector(selector) as HTMLElement | null;
        if (!element) throw new Error(`Element not found for selector: ${selector}`);

        const canvas = await html2canvas(element, {
            width: window.innerWidth,
            height: window.innerHeight,
            scrollX: window.scrollX,
            scrollY: window.scrollY,
            windowWidth: document.documentElement.scrollWidth,
            windowHeight: window.innerHeight,
        });

        const imgDataUrl = canvas.toDataURL('image/jpeg', 1);
        const blob = await (await fetch(imgDataUrl)).blob();

        const file = new File([blob], `screenshot-${Date.now()}.jpg`, {
            type: 'image/jpeg',
        });

        const formData = new FormData();
        formData.append('file', file);

        const { success, response } = await Api.call('POST', '/files', formData);
        if (!success) throw new Error(response?.message ?? 'Upload failed');
        return response.fileId;
    } catch (error: any) {
        console.error('Screenshot upload failed:', error.message ?? 'Unknown error');
    }
};
